import axios from 'axios'

import { normalizeError } from './utils'

const configurationService = () => {
  const fetchConfiguration = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get('/api/configuration', config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  return { fetchConfiguration }
}

export default configurationService()
